import { useTheme } from '../../system';
export var usePP2Theme = () => useTheme();